import { 
  collection, 
  doc, 
  getDocs, 
  updateDoc, 
  query, 
  where,
  getDoc,
  deleteDoc
} from 'firebase/firestore'
import { db } from '../config'
import { UserData } from './auth.service'
import { deleteUserAuth } from './auth.service'

export const getUsers = async () => {
  try {
    const usersRef = collection(db, 'users')
    const snapshot = await getDocs(usersRef)
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
  } catch (error) {
    console.error('Error fetching users:', error)
    throw error
  }
}

export const getUserById = async (id: string) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', id))
    if (!userDoc.exists()) {
      throw new Error('User not found')
    }
    return {
      id: userDoc.id,
      ...userDoc.data()
    }
  } catch (error) {
    console.error('Error fetching user:', error)
    throw error
  }
}

export const updateUser = async (id: string, data: Partial<UserData>) => {
  try {
    const userRef = doc(db, 'users', id)
    await updateDoc(userRef, {
      ...data,
      updatedAt: new Date().toISOString()
    })
    return await getUserById(id)
  } catch (error) {
    console.error('Error updating user:', error)
    throw error
  }
}

export const deleteUser = async (id: string) => {
  try {
    // Deletar o usuário usando o serviço de autenticação
    await deleteUserAuth(id)
    
    // O deleteUserAuth já cuida de inativar o usuário no Firestore
    // e forçar o logout se necessário
    return true
  } catch (error) {
    console.error('Error deleting user:', error)
    throw error
  }
}

export const addOrganizationToUser = async (userId: string, organizationId: string) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId))
    if (!userDoc.exists()) {
      throw new Error('User not found')
    }

    const userData = userDoc.data() as UserData
    const organizations = userData.organizations || []

    // Só adiciona se a organização ainda não estiver na lista
    if (!organizations.includes(organizationId)) {
      organizations.push(organizationId)
      await updateDoc(doc(db, 'users', userId), {
        organizations,
        updatedAt: new Date().toISOString()
      })
    }
  } catch (error) {
    console.error('Error adding organization to user:', error)
    throw error
  }
}

export const removeOrganizationFromUser = async (userId: string, organizationId: string) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId))
    if (!userDoc.exists()) {
      throw new Error('User not found')
    }

    const userData = userDoc.data() as UserData
    const organizations = (userData.organizations || []).filter(id => id !== organizationId)

    await updateDoc(doc(db, 'users', userId), {
      organizations,
      updatedAt: new Date().toISOString()
    })
  } catch (error) {
    console.error('Error removing organization from user:', error)
    throw error
  }
}

export const updateUserOrganizations = async (userId: string, organizationIds: string[]) => {
  try {
    await updateDoc(doc(db, 'users', userId), {
      organizations: organizationIds,
      updatedAt: new Date().toISOString()
    })
  } catch (error) {
    console.error('Error updating user organizations:', error)
    throw error
  }
}

export const getUserOrganizations = async (userId: string) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId))
    if (!userDoc.exists()) {
      throw new Error('User not found')
    }

    const userData = userDoc.data() as UserData
    return userData.organizations || []
  } catch (error) {
    console.error('Error getting user organizations:', error)
    throw error
  }
}